export default function _isString(x) {
  return Object.prototype.toString.call(x) === '[object String]';
}


// WEBPACK FOOTER //
// /Users/stephen.tait/Local Sites/storyiq/app/public/web/wp-content/themes/jaywing/node_modules/ramda/es/internal/_isString.js